module.exports = __webpack_public_path__ + "static/img/js3.88f7acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/js3.png
// module id = 0e8M
// module chunks = 1